// extracted by mini-css-extract-plugin
export default {"wrapper":"C4-z"};